import React, {Fragment, useState, useEffect} from 'react'
import {Button} from 'react-bootstrap'
import '../Overview.css'
import Modal from 'react-bootstrap/Modal'
import Forms from './Form'
import UserService from '../../../../../services/user'
import MasterService from '../../../../../services/master'
import useServices from '../../../../../utils/hooks/useServices'
import Dropdown from 'react-bootstrap/Dropdown'
import {toast} from 'react-toastify'
import Spinner from 'react-bootstrap/Spinner'
import {useSearchParams} from 'react-router-dom'
import MasterServices from '../../../../../services/master'
import {PageTitle} from '_metronic/layout/core'

const Language = () => {
  const [searchParams] = useSearchParams()
  const [show, setShow] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [submit, setSubmit] = useState(false)
  const [data, setData] = useState<any>({})
  const [dataUser, loading, isError, triggerRefresh] = useServices(
    searchParams.get('alumni') ? MasterServices.showUser : UserService.getProfile,
    searchParams.get('alumni')
  )
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [profiencies, setProficiencies] = useState<any>([])
  const [count, setCount] = useState(1)

  useEffect(() => {
    if (searchParams.get('alumni')) {
      setData(dataUser?.data)
    } else {
      setData(dataUser)
    }
  }, [dataUser])

  useEffect(() => {
    getMaster()
    return () => {
    }
  }, [])

  const getMaster = async () => {
    try {
      await MasterService.getProficiency({type: ['LANGUAGE'], is_active: 1}).then((res) => {
        setProficiencies(res.data?.data)
        setCount((val) => (val += 1))
      })
    } catch (error) {}
  }

  const toggle = () => {
    if (show) {
      setIsEdit(false)
      setFormValue({})
    }
    setShow(!show)
  }

  const onChange = (e: any) => {
    const {name, value} = e.target

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleDelete = async (id: any) => {
    try {
      if (!window.confirm('Yakin Ingin Menghapus Bahasa ?')) {
        return
      }
      setLoadingDelete(true)
      setSubmit(true)

      await UserService.deleteLanguage(id).then(() => {
        toast.success('Bahasa berhasil dihapus')
        triggerRefresh()
      })
    } catch (error) {
      toast.success('Bahasa gagal dihapus')
    } finally {
      setSubmit(false)
      setLoadingDelete(false)
    }
  }
  return (
    <div>
      <Modal show={show} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Form' : 'Form'} Bahasa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(count || show) && (
            <Forms
              onChange={onChange}
              editFormValue={formValue}
              toggle={toggle}
              getData={triggerRefresh}
              master={profiencies}
            />
          )}
        </Modal.Body>
      </Modal>
      <div className='row'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-6'>
              {localStorage.getItem('role') == 'Alumni' && (
                <PageTitle
                  breadcrumbs={[
                    {
                      title: 'Dashboard',
                      path: '/dashboard',
                      isSeparator: false,
                      isActive: false,
                    },
                    {
                      title: '/',
                      path: '',
                      isSeparator: false,
                      isActive: false,
                    },
                  ]}
                >
                  Bahasa
                </PageTitle>
              )}
              <h4>Bahasa</h4>
            </div>
            <div className='col-md-6'>
              {!searchParams.get('alumni') && (
                <Button
                  onClick={toggle}
                  className='btn btn-primary btn-sm btn-add'
                  style={{float: 'right'}}
                >
                  Tambah
                </Button>
              )}
            </div>
          </div>
          {/* start data */}
          <div className='col-md-12 d-grid gap-10'>
            <div style={{textAlign: 'center'}}>
              {loading && (
                <Spinner
                  animation='border'
                  role='status'
                  style={{height: '100px', width: '100px'}}
                />
              )}
              {!loading && data?.languages?.length === 0 && <h3>Tidak ada data bahasa</h3>}
            </div>

            <div className='d-grid gap-10'>
              {data?.languages?.map((item: any, key: any) => {
                return (
                  <Fragment key={Math.random()}>
                    <div className='card-custom'>
                      <div className='row'>
                        <div className='col-md-6 p-2'>
                          <h5>{item?.language?.languages_name}</h5>
                        </div>
                        <div className='col-md-6'>
                          {!searchParams.get('alumni') && (
                            <Dropdown>
                              <Dropdown.Toggle
                                id='dropdown-basic'
                                style={{float: 'right'}}
                                className='btn btn-primary btn-sm'
                              >
                                Aksi
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  href='#/action-1'
                                  onClick={() => {
                                    setIsEdit(true)
                                    setFormValue({
                                      proficiencies_id: 1,
                                      description: item?.user_languages_description,
                                      is_certificate: item?.user_languages_certificate,
                                      institution: item?.user_languages_institution,
                                      languages: item?.language?.languages_name,
                                      reading: item?.user_languages_reading,
                                      speaking: item?.user_languages_speaking,
                                      writing: item?.user_languages_writing,
                                      rowDetail: item,
                                    })
                                    toggle()
                                  }}
                                >
                                  Edit
                                </Dropdown.Item>
                                <Dropdown.Item
                                  href='#/action-2'
                                  onClick={() => {
                                    handleDelete(item?.user_languages_id)
                                  }}
                                >
                                  Hapus
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        </div>
                        <div className='col-md-12'>
                          <div className='row'>
                            <div className='col-md-4 p-2'>
                              <p>Kemampuan Percakapan</p>
                              <p className='fw-bold'>{item.speaking?.proficiencies_name}</p>
                            </div>
                            <div className='col-md-4 p-2'>
                              <p>Kemampuan Membaca</p>
                              <p className='fw-bold'>{item.reading?.proficiencies_name}</p>
                            </div>
                            <div className='col-md-4 p-2'>
                              <p>Kemampuan Menulis</p>
                              <p className='fw-bold'>{item.writing?.proficiencies_name}</p>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='col-md-4 p-2'>
                              <p>Sertifikat</p>
                              <p className='fw-bold'>
                                {item?.user_languages_certificate == 1 ? 'Ya' : 'Tidak'}
                              </p>
                            </div>
                            <div className='col-md-4 p-2'>
                              <p>Institusi Penerbit</p>
                              <p className='fw-bold'>{item?.user_languages_institution ?? '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className='col-md-12 p-2'>
                          <p>Deskripsi Kemampuan</p>
                          <p className='fw-bold'>{item?.user_languages_description ?? '-'}</p>
                        </div>
                        {item?.document_url_full && item?.user_languages_certificate == 1 ? (
                          <div className='col-md-12 p-2'>
                            <p>Dokumen Pendukung</p>
                            <a
                              href={item?.document_url_full}
                              target='_blank'
                              className='btn btn-primary btn-sm'
                            >
                              Sertifikat
                            </a>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Fragment>
                )
              })}
            </div>
          </div>
          {/* end data */}
          {/* end content */}
        </div>
      </div>
    </div>
  )
}

export default Language
